// COMPRAS requests
export const COMPRAS_LIST = "COMPRAS_LIST";
export const COMPRAS_FULLLIST = "COMPRAS_FULLLIST";
export const COMPRAS_LISTA = "COMPRAS_LISTA";
export const COMPRAS_CREATE = "COMPRAS_CREATE";
export const COMPRAS_CREATE_FORM = "COMPRAS_CREATE_FORM";
export const COMPRAS_FILTER = "COMPRAS_FILTER";
export const COMPRAS_UPDATE = "COMPRAS_UPDATE";
export const COMPRAS_DELETE = "COMPRAS_DELETE";
export const COMPRAS_READ = "COMPRAS_READ";

// COMPRAS success
export const COMPRAS_LIST_SUCCESS = "COMPRAS_LIST_SUCCESS";
export const COMPRAS_FULLLIST_SUCCESS = "COMPRAS_FULLLIST_SUCCESS";
export const COMPRAS_CREATE_SUCCESS = "COMPRAS_CREATE_SUCCESS";
export const COMPRAS_CREATE_FORM_SUCCESS = "COMPRAS_CREATE_FORM_SUCCESS";
export const COMPRAS_UPDATE_SUCCESS = "COMPRAS_UPDATE_SUCCESS";
export const COMPRAS_DELETE_SUCCESS = "COMPRAS_DELETE_SUCCESS";
export const COMPRAS_READ_SUCCESS = "COMPRAS_READ_SUCCESS";

// COMPRAS failed
export const COMPRAS_REQUEST_FAILED = "COMPRAS_REQUEST_FAILED";
